<template>
  <div class="sp-template">
    <div class="h-title">客户余额</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="demo-form-inline" size="small">
            <el-form-item label="系统">
            <el-select v-model="queryForm.system" filterable placeholder="请选择系统" @change="onSubmit">
              <el-option v-for="item in systems" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="结算周期">
            <el-select v-model.lazy="queryForm.settlementCycle" clearable filterable placeholder="请选择结算周期" @change="onSubmit">
              <el-option v-for="(d, i) in settlementCycles" :key="i" :label="d.name" :value="d.value"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="客户">
            <el-select v-model.lazy="queryForm.orgOwner" clearable filterable placeholder="请选择客户" @change="onSubmit">
              <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员">
            <el-select v-model.lazy="queryForm.salesman" clearable filterable placeholder="请选择业务员" @change="onSubmit">
              <el-option v-for="(d, i) in salesmans" :key="i" :label="userMap[d]" :value="d"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服">
            <el-select v-model.lazy="queryForm.customerServiceStaff" clearable filterable placeholder="请选择客服" @change="onSubmit">
              <el-option v-for="(d, i) in customerServiceStaffs" :key="i" :label="userMap[d]" :value="d"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker v-model.lazy="queryForm.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="截止日期"></el-date-picker>
          </el-form-item>  
          <el-form-item>
            <el-button v-if="in_configs(801)" type="primary" @click="onSubmit">搜 索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(802)" type="primary" @click="exportExcel(1)">导出当前页</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(803)" type="primary" @click="exportExcel(2)">导出全部</el-button>
          </el-form-item>
        </el-form>
        <div>
          <!-- <el-button size="small" @click="generatingBill" class="el-button btn-cyan">生成账单</el-button> -->
        </div>
      </div>
      <el-table :data="customers" stripe @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        
        <el-table-column prop="customerName" label="客户"></el-table-column>
        <el-table-column prop="companyName" label="分公司"></el-table-column>
        <el-table-column prop="salesmanName" label="业务员"></el-table-column>
        <el-table-column prop="customerServiceStaffName" label="客服"></el-table-column>
        <el-table-column label="结算方式">
          <template slot-scope="scope">
            {{settlementCycleMap[scope.row.paymentTerms]}}
          </template>
        </el-table-column>   
        <!-- <el-table-column prop="paymentTermsName" label="结算方式"></el-table-column> -->
        <el-table-column prop="credits" label="信用金额"></el-table-column>
        <el-table-column prop="currentBalance" label="实时余额"></el-table-column>
        <el-table-column prop="balance" label="余额"></el-table-column>        
        <el-table-column prop="currentMonthBillDebt" label="当月欠款"></el-table-column>
        <el-table-column prop="lastMonthBillDebt" label="上月欠款"></el-table-column>
        <el-table-column prop="historyBillDebt" label="历史欠款"></el-table-column>
        <el-table-column prop="minimumPayment" label="最低付款金额"></el-table-column>

      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>

    <form action="" method="post" target="_blank" id="myform"  >
      </form>

  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

export default {
  data() {
    return {
      form: { test: "text" },
      customerList: [],
      customerMap: {},
      customers: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      queryForm: {
        orgOwner: "",
        settlementCycle: "",
        salesman: "",
        customerServiceStaff: "",
        endDate: "",
        export: 0,
        timeType: "charge",
        pageSize: 10,
        currentPage: 1,
        system: "TMS"
      },
      customerIds: [],
      selectCustomer: [],
      systems: [
        {
          value: "TMS",
          label: "TMS物流系统"
        },
        {
          value: "PP",
          label: "小包物流系统"
        },
        {
          value: "WMS",
          label: "WMS仓库系统"
        }
      ],
      customerTypeList: [
        { name: "普通客户", value: "NORMAL" },
        { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        { name: "线上代理", value: "ONLINE_AGENCY" },
        { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      salesmans: [],
      customerServiceStaffs: [],
      settlementCycles: [],
      settlementCycleMap: {},
      userMap: {}
      
    };
  },
  components: {},
  created() {
      let _this = this;
   // this.getSettlement();
    this.queryForm.endDate = this.formatDate(new Date(), "yyyy-MM-dd") + ' 23:59:59';

    // _this.$-axios.all([_this.getSettlement(), _this.findByCustomerName()])
    // .then(_this.$-axios.spread(function (data1, data2) {
    //      _this.loadCustomerList();
    // }));

    Promise.all([_this.getSettlement(), _this.findByCustomerName()])
    .then(([data1, data2]) => {
      _this.loadCustomerList();
    });

    // setTimeout(() => {
    //     this.findByCustomerName();
    //     this.loadCustomerList();
    // }, 1000);
  },
  computed: {},
  methods: {
      
    getSettlement() {
      let _this = this;
      _this.$request1({
          method: 'GET',
          url: '/customer/settlement',
          withCredentials: true
        })
        .then(res => {
          _this.settlementCycles = res.data;
          _this.settlementCycles.forEach(a => {
                _this.settlementCycleMap[a.value] = a.name;
            });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //多选按钮
    handleSelectionChange(val) {
      this.selectCustomer = val;
    },
    //搜索
    onSubmit() {
      this.queryForm.currentPage = 1;
      this.loadCustomerList();
    },

    //分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.currentPage = 1;
      this.loadCustomerList();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.loadCustomerList();
    },
    loadCustomerList() {
      let _this = this;
      this.queryForm.export = 0;
      
      _this.$request1
        .post(
        '/customer/balance',
        _this.queryForm,
        {
            withCredentials: true
        }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data.list;
            _this.userMap = res.data.data.userMap;

            _this.salesmans = res.data.data.salesmans;
            _this.customerServiceStaffs = res.data.data.customerServiceStaffs;
        
            _this.total = res.data.total;
          } else {
            _this.customers = [];
            _this.total = 0;
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    exportExcel(val){
        let _this = this;
        var url = '/customer/balance';
        _this.queryForm.export = val;

        this.$request1({
          url: url,
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `balance_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })



        // _this.queryForm.export = val;
        //  var url = '/customer/balance';
        //  var form = document.getElementById("myform")
        //  form.setAttribute('action', url);         
        // var childs = form.childNodes; 
        // for(var i = childs.length - 1; i >= 0; i--) { 
        //     form.removeChild(childs[i]); 
        // } 

        /*var fhtml = '';
        for (var key in _this.queryForm){
            fhtml += '<input type="hidden" name="' + key + '" value="' + (_this.queryForm[key]==null?"":_this.queryForm[key]) + '" />';
        }
        fhtml += '<input type="hidden" name="data" value="' + JSON.stringify(_this.queryForm) + '" />';
        form.innerHTML = fhtml*/

      //   var input = document.createElement("input");
  		// input.type="hidden";
  		// input.name= 'data';
  		// input.value=JSON.stringify(_this.queryForm);
      //   form.appendChild(input);          
      //   //console.log(form);
      //   form.submit();        
    },
    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customer/querycustomerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customerList = res.data.data;
            _this.customerList.forEach(a => {
                _this.customerMap[a.id] = a.name;
            });
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/report/balance.vue